import { useUtilityStore } from "~/store/UtililityStore";
// https://unpkg.com/browse/language-icons@0.3.0/icons/
import uk from "@/assets/language/uk.svg";
import fr from "@/assets/language/fr.svg";
import nl from "@/assets/language/nl.svg";
import sv from "@/assets/language/sv.svg";
import de from "@/assets/language/de.svg";
import es from "@/assets/language/es.svg";
import it from "@/assets/language/it.svg";
import pt from "@/assets/language/pt.svg";
import pl from "@/assets/language/pl.svg";
import jp from "@/assets/language/ja.svg";
import ar from "@/assets/language/ar.svg";
import ro from "@/assets/language/ro.svg";

export const useUtils = () => {
  const utilityStore = useUtilityStore();
  const selectedLocale = computed(() => utilityStore.selectedLocale);
  const selectedLanguage = computed(() => utilityStore.selectedLanguage);

  const showDecimalValueInLocale = computed(() => {
    return (v) => {
      if (v) {
        try {
          return Number(v).toFixed(2).toLocaleString(selectedLocale.value);
        } catch (error) {
          return v;
        }
      }
      return "";
    };
  });

  const productTitle = computed(
    () => (name) =>
      name[selectedLanguage.value] || name["fr_BE"] || name["en_GB"] || name
  );
  const productLinkTitle = computed(
    () => (name) =>
      (name[selectedLanguage.value] || name["en_GB"] || name["fr_BE"] || name).replaceAll(/[^a-zA-Z0-9]+/g, '-').toLowerCase()
  );
  

  return { showDecimalValueInLocale, productTitle, productLinkTitle };
};

export const languageMap = {
  en: uk,
  fr: fr,
  nl: nl,
  sv: sv,
  de: de,
  es: es,
  it: it,
  pt: pt,
  pl: pl,
  jp: jp,
  ar: ar,
  ro: ro,
  pt_dsh_br: pt,
};

export let gsapInstance = null;

export const loadGsap = async () => {
  if (!gsapInstance) {
    gsapInstance = await import("gsap");
  }
  return gsapInstance;
};
